/**
 * PUS（開催回）タグによる購入制御 — カートページ
 *
 * 別開催の PUS タグ（PUS1 / PUS2 …）が付いた商品が同一カートに混在している場合、
 * 注文手続きへ進めないようにする。
 *
 * 判定のソースは各カート行の data-pus-group 属性（main-cart.liquid が出力）。
 * halo.updateCart() は商品行だけを差し替えて完了時に cart-update イベントを投げるため、
 * 同イベントで再判定し、警告表示と CTA の状態をカートの実態に追従させる。
 */
(function () {
  'use strict';

  var BLOCKED_BODY_CLASS = 'cart-pus-blocked';

  /* 注文手続きへ進む可能性のあるコントロール。
     .button-disable はモバイル sticky バーを開くだけのトグルなので対象外にする。 */
  var CHECKOUT_CONTROLS = [
    '#cart-checkout',
    '[name="checkout"]',
    '.button-checkout:not(.button-disable)',
    '.additional-checkout-buttons a',
    '.additional-checkout-buttons button',
    '.dynamic-checkout__content button',
    '.shopify-payment-button__button',
    'a[href*="/checkout"]',
    '[data-href*="/checkout"]'
  ].join(',');

  var isBlocked = false;

  function getAlerts() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cart-pus-alert]'));
  }

  function detectGroups() {
    var rows = document.querySelectorAll('#main-cart-items [data-pus-group]');
    var groups = [];

    Array.prototype.forEach.call(rows, function (row) {
      var group = (row.getAttribute('data-pus-group') || '').trim();
      if (group && groups.indexOf(group) === -1) groups.push(group);
    });

    return groups;
  }

  function syncCheckoutControls() {
    var controls = document.querySelectorAll('#cart-checkout, .button-checkout:not(.button-disable)');

    Array.prototype.forEach.call(controls, function (control) {
      if (isBlocked) {
        control.setAttribute('aria-disabled', 'true');
      } else {
        control.removeAttribute('aria-disabled');
      }
    });
  }

  function sync() {
    var groups = detectGroups();

    isBlocked = groups.length > 1;
    document.body.classList.toggle(BLOCKED_BODY_CLASS, isBlocked);

    getAlerts().forEach(function (alert) {
      alert.hidden = !isBlocked;
    });

    syncCheckoutControls();
  }

  /* 表示中の警告のうち、注文手続きボタンに最も近いもの（＝最後のもの）へ誘導する */
  function highlightAlert() {
    var alerts = getAlerts();
    var target = null;

    for (var i = alerts.length - 1; i >= 0; i--) {
      if (!alerts[i].hidden && alerts[i].offsetParent !== null) {
        target = alerts[i];
        break;
      }
    }
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target.classList.remove('is-flash');
    void target.offsetWidth; // アニメーションを再生させるための強制リフロー
    target.classList.add('is-flash');
  }

  function onCaptureClick(event) {
    if (!isBlocked) return;
    if (!(event.target instanceof Element)) return;

    if (!event.target.closest(CHECKOUT_CONTROLS)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    highlightAlert();
  }

  function onCaptureSubmit(event) {
    if (!isBlocked) return;

    var form = event.target;
    var action = form.getAttribute('action') || '';

    if (action.indexOf('/checkout') === -1 && !form.querySelector('[name="checkout"]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    highlightAlert();
  }

  function init() {
    if (!document.getElementById('main-cart-items')) return;

    /* テーマ / アプリ側のハンドラより先に止めるためキャプチャフェーズで待ち受ける */
    document.addEventListener('click', onCaptureClick, true);
    document.addEventListener('submit', onCaptureSubmit, true);
    document.addEventListener('cart-update', sync);

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
